import React from "react";

const SessionWarning = ({ secondsLeft, stayLoggedIn }) => {
  return (
    <div
      className="session-warning"
      style={{
        position: "fixed",
        top: "20px",
        left: "50%",
        transform: "translateX(-50%)",
        background: "#fff8e1",
        padding: "20px 25px",
        boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
        borderRadius: "12px",
        zIndex: 9999,
        width: "320px",
        fontFamily: "Arial, sans-serif",
        textAlign: "center",
        borderLeft: "6px solid #ffc107",
        animation: "fadeInDown 0.5s ease",
      }}
    >
      <h4 style={{ marginBottom: "10px", color: "#d9534f" }}>
        ⚠ Session Expiring
      </h4>

      <p style={{ marginBottom: "20px", fontSize: "16px", color: "#333" }}>
        Your session will expire in <b>{secondsLeft}</b> seconds
      </p>

      <button
        onClick={stayLoggedIn}
        style={{
          width: "100%",
          padding: "10px",
          backgroundColor: "#28a745",
          border: "none",
          color: "white",
          fontWeight: "bold",
          fontSize: "16px",
          borderRadius: "6px",
          cursor: "pointer",
          transition: "all 0.2s ease",
        }}
      >
        Stay Logged In
      </button>

      <style>{`
        @keyframes fadeInDown {
          0% {
            opacity: 0;
            transform: translateY(-30px);
          }
          100% {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  );
};

export default SessionWarning;